module.exports = __webpack_public_path__ + "img/closelink.c382653c.svg";